import _http from './_http';
import { logWebHrError } from '@/core/logger/log-wrapper';
let http = _http;

if (process.env.MOCK) {
  const mock = require('./_mock.json');
  http = {
    get: (bsb) =>
      Promise.resolve().then(() => {
        if (bsb.match('000-000') || bsb.match('000000')) {
          return Promise.reject(mock.bsb.error);
        }

        return { data: mock.bsb.success };
      }),
  };
}

const baseUrl = '/onboarding/bsb';

export default {
  url: `${http.baseUrl}${baseUrl}`,
  get(bsb) {
    return http
      .get(`${baseUrl}/${bsb}`)
      .then(({ data }) => data.data)
      .catch((e = {}) => {
        if (e?.response?.status !== 404) {
          logWebHrError({
            message: 'Failed to load bsb',
            source: 'bsb',
            metadata: {
              baseUrl,
              hasBsb: !!bsb,
            },
            error: e,
          });
        }

        throw e.response;
      });
  },
};
